module.exports = __webpack_public_path__ + "static/img/google.549dda6e.png";